import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit, OnChanges {
  mobile: boolean = false;
  constructor() {
  }

  @Input() content: String;
  @Input() error: boolean = false;
  @Input() success: boolean = false;
  @Input() display: boolean;
  @Input() ignoreOffset: boolean = false;
  @Input() isChildElement: boolean = false;
  @Input() timeOut: number = 5000
  @Input() locked: boolean = false;
  @Output() notificationClosed = new EventEmitter();

  ngOnInit(): void {
    if (window.screen.width <= 1000) { // 768px portrait
      this.mobile = true;
    }
    if (this.timeOut > 0)
      this.checkTimeout()

  }

  ngOnChange(): void {
    if (this.timeOut > 0)
      this.checkTimeout()
  }

  hideNotification() {
    this.display = false;
    this.closeNotification();
  }

  checkTimeout() {
    let that = this;
    if (this.display)
      setTimeout(function () {
        that.display = false;
        that.closeNotification()
      }, this.timeOut)
  }

  closeNotification(){
    this.notificationClosed.emit();
  }

  ngOnChanges(changes: SimpleChanges) {

    if(changes.content.currentValue && changes.content.currentValue !== changes.content.previousValue){
      let myElement = document.getElementById('notification-container');
      let topPos = myElement.offsetTop;

      if(this.isChildElement){
        $('*#scrollbar').each(function() {
          $(this).animate({
            scrollTop: 0
          }, 'slow');
        });
      }

      else if(!this.ignoreOffset){
        $('html,body').animate({
          scrollTop: $("#notification-container").offset().top
        }, 'slow');
      }
      else{
        $('html,body').animate({
          scrollTop: 0
        }, 'slow');
      }
    }

  }


}
